// import React from "react";
// import moment from "moment";
import axios from 'axios';
import{
	_axiosCall,
	_getUserEvents
} from '../../../helpers/apicalls';
import{
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage
} from '../../../helpers/utils';

import buyersListActions from '../../../../redux/actions/buyersListActions';
import { Publisher } from "./../../../pubsub/publisher.js";


export const  _getUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
  
  const ssoOrg = _getSSOOrg();
  
  if(ssoOrg == "MPSSO"){
	  return _getMPUserAuth0SSO(ssoToken, props, setUserProfile);
	  //return _getMPUserSSO(ssoToken, props, setUserProfile);
  }
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.REALOGY_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  
  let combinedUser
  return _axiosCall(userData)
	.then(res => {
	console.log("_getUserData res back ,", res);
	if(res){
	  let oktaUser = Object.assign({}, res);
	  oktaUser['authType'] = 'sso';
	  oktaUser['role'] = ['complete-199'];
	  oktaUser['subscriptionPlan'] = 'custom-sso';
	  oktaUser['id']= res.sub;
	  oktaUser['firstName'] = res.given_name;
	  oktaUser['lastName'] = res.family_name;
	  oktaUser['title'] = "Real Estate Professional";
	  oktaUser['company'] = "Coldwell Banker Warburg";
	  oktaUser['subscriptionId'] = 'custom-sso';
	  oktaUser['ssoOrganiztion'] = 'cbwarburg';
	 
	  //if((oktaUser.email && oktaUser.email.indexOf("cbwarburg.com")>=0)){
			  _getUser(oktaUser).then(user => {
				  if(user){
					  
					   combinedUser = Object.assign({}, oktaUser, user);
					   _getUserEvents(combinedUser).then(results =>{
						   if(results && results[0] && results[0].shown){
							   combinedUser = Object.assign({}, combinedUser, {"contactsShown" : results[0].shown})
						   }
						  dispatch(setUserProfile(combinedUser));
						  dispatch(buyersListActions.setUserData(combinedUser));
						  Publisher.publish("login", combinedUser);
						   
					   })
					  
				  }else{
					_checkWarburgAuthorization(oktaUser).then(result => {
						
						if(result && result.authentication === true){
							_createUser(oktaUser).then(user => {
								  combinedUser = Object.assign({}, oktaUser, user);
								  dispatch(setUserProfile(combinedUser));
								  dispatch(buyersListActions.setUserData(combinedUser));
								  Publisher.publish("login", combinedUser);
							})
						}else{
							_deleteSSOToken();
							window.location.href = "/cbwarburg?error=unauthorized";
						}
						
						
					}).catch(error =>{
						console.log(error);
						dispatch(setUserProfile(null));
						_deleteSSOToken();
						window.location.href = "/cbwarburg?error=unauthorized";
					});
					  
				  }
			  }).catch(error =>{
				  console.log(error);
				 dispatch(setUserProfile(null));
				 _deleteSSOToken();
				  window.location.href = "/cbwarburg?error=unauthorized";
			});
	  //   }else{
		// 	window.location.href = "/login";
	  // }
	}else{
			dispatch(setUserProfile(null));
			_deleteSSOToken();
			window.location.href = "/cbwarburg?error=unauthorized";
	}
	return combinedUser;

  })
  .catch(error => {
	
	if(error && error.status && error.status == 401){
		console.log("error 401")
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	}
	console.log(error)
	
  });
}

export const  _getMPUserSSO = async (ssoToken, props, setUserProfile) => {

  const { authState, authService, dispatch } = props;
	  
  let headers = {
	"Authorization" : `Bearer ${ssoToken.access_token}`,
  }
  let userData = {
	  url: `${process.env.MP_BASE_URL}userinfo`,
	  method: "get",
	  headers:headers
  };
  
  
  return _axiosCall(userData)
	.then(res => {
	console.log("_getUserData res back ,", res);
	if(res){
	
	  let oktaUser = Object.assign({}, res);
			  oktaUser['id']= res.sub;
			oktaUser['authType'] = 'sso';
			oktaUser['ssoType'] = 'MPSSO';
			if(res.AllProfile){
				oktaUser = Object.assign({}, oktaUser, res.AllProfile);
			}
			  _getUser(oktaUser).then(user => {
				  console.log(user)
				  if(user){
					  
					  let combinedUser = Object.assign({}, user, oktaUser);
					  _getUserEvents(combinedUser).then(results =>{
						 if(results && results[0] && results[0].shown){
							 combinedUser = Object.assign({}, combinedUser, {"contactsShown" : results[0].shown})
						 }
						dispatch(setUserProfile(combinedUser));
						dispatch(buyersListActions.setUserData(combinedUser));
						Publisher.publish("login", combinedUser);
						 
					 })
					 
				  }else{
					dispatch(setUserProfile(oktaUser));
					Publisher.publish("login", (oktaUser));
					//_deleteSSOToken();
					  
				  }
			  }).catch(error =>{
				  console.log(error);
				  dispatch(setUserProfile(null));
				  _deleteSSOToken();
			});
	}else{
			dispatch(setUserProfile(null));
			_deleteSSOToken();
	}
	

  })
  .catch(error => {
	
	if(error && error.status && error.status == 401){
		console.log("error 401")
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	}
	console.log(error)
	
  });
}
export const _getMPUserAuth0SSO = function (ssoToken, props, setUserProfile) {
  var dispatch = props && props.dispatch ? props.dispatch : function () {};

  var apiBase = '';
  if (typeof process !== 'undefined' && process.env && process.env.API_ROOT) {
	apiBase = String(process.env.API_ROOT).replace(/\/+$/, '');
  }
  var meUrl = apiBase ? (apiBase + '/auth0/me') : '/auth0/me';

  var idToken = ssoToken && ssoToken.id_token ? ssoToken.id_token : '';

  // POST with token in query to avoid preflight
  var userData = {
	url: meUrl,
	method: 'post',
	query: { token: idToken }
  };

  function finishAndReturn(combinedUser) {
	try {
	  combinedUser['avatar'] = combinedUser['avatar'] ? combinedUser['avatar'] : "https://buyerslist.s3.amazonaws.com/account.png";
		dispatch(setUserProfile(combinedUser));
		if (typeof buyersListActions !== 'undefined' &&
			buyersListActions &&
			buyersListActions.setUserData) {
		  
		  dispatch(buyersListActions.setUserData(combinedUser));
		}
		if (typeof Publisher !== 'undefined' && Publisher && Publisher.publish) {
		  Publisher.publish('login', combinedUser);
		}
	  
	  
	} catch (e) {
	  console.log(e);
	}
	return combinedUser;
  }

  return _axiosCall(userData)
	.then(function (srvProfile) {
	  try {
		if (!srvProfile || typeof srvProfile !== 'object') {
		  dispatch(setUserProfile(null));
		  _deleteSSOToken();
		  return null;
		}

		// Build app user from flattened server profile
		var rawUserId = srvProfile.user_id || '';
		// Remove "auth0|okta|" prefix if present
		var cleanedId = rawUserId.replace(/^auth0\|okta\|/, '');

		var auth0User = Object.assign({}, srvProfile, {
		  id: cleanedId,
		  user_id: cleanedId,
		  authType: 'sso',
		  ssoType: 'AUTH0'
		});
		
		if(srvProfile && srvProfile.user_metadata && typeof srvProfile.user_metadata === 'object'){
			auth0User =  Object.assign({}, auth0User, srvProfile.user_metadata);
		}
		if(srvProfile && srvProfile.app_metadata &&  typeof srvProfile.app_metadata === 'object'){
			auth0User =  Object.assign({}, auth0User, srvProfile.app_metadata);
		}

		// Normalize groups
		if (!Array.isArray(auth0User.groups)) auth0User.groups = [];

		// Avatar fallback
		if (!auth0User.avatar) {
		  if (auth0User.picture) auth0User.avatar = auth0User.picture;
		  else auth0User.avatar = 'https://buyerslist.s3.amazonaws.com/account.png';
		}

		// Try to fetch existing user
		return _getUser(auth0User)
		  .then(function (user) {
			if (user) {
			  // Match your example: DB user overrides SSO fields
			  var combinedUser = Object.assign({}, user, auth0User);
			  return finishAndReturn(combinedUser);
			} else {
			  // Create user if not found
			  return _createUser(auth0User)
				.then(function (newUser) {
				  var combinedUser = Object.assign({}, newUser, auth0User);
				  return finishAndReturn(combinedUser);
				})
				.catch(function (createErr) {
				  console.log(createErr);
				  dispatch(setUserProfile(null));
				  _deleteSSOToken();
				  return null;
				});
			}
		  })
		  .catch(function (getErr) {
			// If API signals not found, attempt create
			if (getErr && getErr.status === 404) {
			  return _createUser(auth0User)
				.then(function (newUser) {
				  var combinedUser = Object.assign({}, newUser, auth0User);
				  return finishAndReturn(combinedUser);
				})
				.catch(function (createErr) {
				  console.log(createErr);
				  dispatch(setUserProfile(null));
				  _deleteSSOToken();
				  return null;
				});
			}
			console.log(getErr);
			dispatch(setUserProfile(null));
			_deleteSSOToken();
			return null;
		  });
	  } catch (e) {
		console.log(e);
		dispatch(setUserProfile(null));
		_deleteSSOToken();
		return null;
	  }
	})
	.catch(function (error) {
	  if (error && error.status && error.status === 401) {
		console.log('error 401');
		dispatch(setUserProfile(null));
		_deleteSSOToken();
	  }
	  console.log(error);
	  return null;
	});
};
export const _getUser = async (user) => {
		
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/userdata/${user.id}`,
			method: "get"
		};
		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				if(res && res.length>0){
					return res[0];
				}else{
					return false;
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});
		return formattedData;
};

export const _createUser = async (user) => {
		
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/createssouser/${user.id}`,
			method: "post",
			query: user
		};

		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				console.log('Data', res);
				if(res && res.length>0){
					return res[0];
				}else{
					return false;
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});

		// console.log(formattedData)
		return formattedData;
};


export const  _doUserSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoOrg = _getSSOOrg();
 
  if(ssoOrg == "MPSSO"){
	return _doUserMPAuth0SSOLogout(props, setUserProfile);
	//return _doUserMPSSOLogout(props, setUserProfile);
  }
	
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.REALOGY_BASE_URL}logout?client_id=${process.env.REALOGY_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.REALOGY_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}

export const  _doUserMPSSOLogout = async (props, setUserProfile) => {
  const { authState, authService, dispatch } = props;
  const ssoToken = _getSSOToken();
  if(ssoToken && ssoToken.id_token){
	  const logURL = `${process.env.MP_BASE_URL}logout?client_id=${process.env.MP_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.MP_LOGOUT_REDIRECT_URI}`;
	  _deleteSSOToken();
	  
	  Publisher.publish("logout", {});
	  window.location.href = logURL;
	  //dispatch(setUserProfile(null));
	  return false;
  }
}
export const _doUserMPAuth0SSOLogout = function (props, setUserProfile) {
  var dispatch = props && props.dispatch ? props.dispatch : function () {};

  // Build Auth0 logout URL
  var auth0Base = '';
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_AUTH0_DOMAIN) {
	auth0Base = String(process.env.REACT_APP_AUTH0_DOMAIN).replace(/\/+$/, '');
	if (auth0Base.indexOf('http') !== 0) auth0Base = 'https://' + auth0Base;
  }

  var clientId = '';
  if (typeof process !== 'undefined' && process.env) {
	if (process.env.REACT_APP_AUTH0_CLIENT_ID) clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
	else if (process.env.MP_CLIENT_ID) clientId = process.env.MP_CLIENT_ID; // fallback if you reuse envs
  }

  var returnTo = '';
  if (typeof process !== 'undefined' && process.env) {
	if (process.env.MP_LOGOUT_REDIRECT_URI) returnTo = process.env.MP_LOGOUT_REDIRECT_URI;
  }
  if (!returnTo && typeof window !== 'undefined' && window.location && window.location.origin) {
	returnTo = window.location.origin;
  }

  var logoutURL = auth0Base + '/v2/logout?client_id=' + encodeURIComponent(clientId) +
				  '&returnTo=' + encodeURIComponent(returnTo);

  // Clear local SSO state before redirect
  try { _deleteSSOToken(); } catch (e) { /* noop */ }
  try { if (typeof Publisher !== 'undefined' && Publisher && Publisher.publish) Publisher.publish('logout', {}); } catch (e) { /* noop */ }
  try { if (typeof dispatch === 'function' && setUserProfile) dispatch(setUserProfile(null)); } catch (e) { /* noop */ }

  if (typeof window !== 'undefined') {
	window.location.href = logoutURL;
  }
  return false;
};
export const _checkWarburgAuthorization = (user) => {
	return new Promise((resolve, reject) => {
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/realogy/cbwarburg`,
			method: "get"
		};
		
		let formattedData = _axiosCall(axiosData)
			.then(res => {
				//console.log(user, res)
				if(user && user.id && res && res.agents && res.agents.filter(agent => agent && agent.companyOfficeAssociation && agent.companyOfficeAssociation.agentOktaIds && agent.companyOfficeAssociation.agentOktaIds.indexOf(user.id)>=0).length>0){
					resolve({authentication:true, agent: user})
					
				}
				resolve({authentication:false, agent: user});
				
			})
			.catch(error => {
				reject(Error(error));
			});
		
		// console.log(formattedData)
		return formattedData;
	  });

};

export const _setSSOToken = (ssoToken, ssoOrg) => {
	ssoOrg = ssoOrg ? ssoOrg : 'CBWarburg';
	deleteLocalStorage("mpsso", "_ssoTokenType");
	setLocalStorage("mpsso", "_ssoTokenType", ssoOrg);
	return setLocalStorage(ssoOrg, '_SSOToken', ssoToken);
}

export const _deleteSSOToken = () => {
	const ssoOrg = getLocalStorage("mpsso", "_ssoTokenType");
	deleteLocalStorage(ssoOrg, '_SSOToken');
	return deleteLocalStorage("mpsso", "_ssoTokenType");
}
export const _getSSOToken = () => {

	const ssoOrg = getLocalStorage("mpsso", "_ssoTokenType");
	return getLocalStorage(ssoOrg, '_SSOToken')
}

export const _getSSOOrg = () => {
	return getLocalStorage("mpsso", "_ssoTokenType");
}

export const _doSSOLogout = (props, setUserProfile) => {
	const ssoOrg = getLocalStorage("mpsso", "_ssoTokenType");
	return _doUserSSOLogout(props, setUserProfile, ssoOrg)
}

export const decodeIdToken = (idToken) => {
  try {
	const parts = idToken.split('.');
	if (parts.length !== 3) return null;

	const payload = parts[1];
	const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
	return decoded;
  } catch (e) {
	console.error("Error decoding ID token:", e);
	return null;
  }
};
